// [Jake UI] - Loading skeleton placeholders for dashboard filter panels
import React from "react";

// Reusable shimmer bar
const SkeletonBar = ({ width = "100%", height = 14, style = {} }) => (
  <div
    className="match-skeleton-card__shimmer-wrap"
    style={{
      width,
      height,
      borderRadius: 6,
      overflow: "hidden",
      background: "var(--neutral-195)",
      ...style,
    }}
  >
    <div className="match-skeleton-card__shimmer" />
  </div>
);

// Skeleton for the Buyers tab filter bar (location, sort, property type dropdowns)
export const FilterBarSkeleton = () => (
  <div style={{ padding: "0 18px" }}>
    <div style={{ display: "flex", flexDirection: "column", gap: 14, paddingTop: 8 }}>
      <SkeletonBar width="100%" height={36} />
      <div style={{ display: "flex", gap: 8 }}>
        <SkeletonBar width="48%" height={32} />
        <SkeletonBar width="48%" height={32} />
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <SkeletonBar width="32%" height={28} />
        <SkeletonBar width="32%" height={28} />
        <SkeletonBar width="32%" height={28} />
      </div>
      <SkeletonBar width="60%" height={14} style={{ marginTop: 8 }} />
    </div>
  </div>
);

// Table skeleton for dashboard list pages (Want-Listings, Inventory, Clients)
export const DashboardTableSkeleton = ({ rows = 5, columns = 4 }) => (
  <div style={{ padding: "0 0 16px" }}>
    {/* Header row */}
    <div style={{ display: "flex", gap: 16, padding: "12px 0", borderBottom: "1px solid var(--neutral-280)" }}>
      {Array.from({ length: columns }).map((_, i) => (
        <SkeletonBar key={i} width={i === 0 ? "30%" : `${70 / (columns - 1)}%`} height={14} />
      ))}
    </div>
    {/* Data rows */}
    {Array.from({ length: rows }).map((_, rowIdx) => (
      <div
        key={rowIdx}
        style={{
          display: "flex",
          gap: 16,
          padding: "16px 0",
          borderBottom: "1px solid var(--neutral-280)",
          opacity: 1 - rowIdx * 0.12,
        }}
      >
        {Array.from({ length: columns }).map((_, colIdx) => (
          <SkeletonBar
            key={colIdx}
            width={colIdx === 0 ? "30%" : `${70 / (columns - 1)}%`}
            height={14}
            style={colIdx === 0 ? {} : { maxWidth: 120 + colIdx * 30 }}
          />
        ))}
      </div>
    ))}
  </div>
);

// Skeleton for the Match tab (property selector + client selector + filters)
export const MatchTabSkeleton = () => (
  <div style={{ padding: "0 18px" }}>
    <div style={{ display: "flex", flexDirection: "column", gap: 14, paddingTop: 8 }}>
      <SkeletonBar width="100%" height={40} />
      <SkeletonBar width="100%" height={40} />
      <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
        <SkeletonBar width="50%" height={28} />
        <SkeletonBar width="50%" height={28} />
      </div>
      <SkeletonBar width="45%" height={14} style={{ marginTop: 8 }} />
    </div>
  </div>
);
